import { buildJobPageSeoDescription, buildJobPageSeoTitle } from "./jobPostingSeo";
import { buildPublicPageUrl } from "./pageSeo";
import { jobPublicHref } from "./jobPublicPath";

/** Canonical public URL for a job — use for copy + social share (never window.location). */
export function buildJobShareUrl(job) {
  return buildPublicPageUrl(jobPublicHref(job));
}

export function buildJobShareTitle(job) {
  return buildJobPageSeoTitle(job);
}

export function buildJobShareDescription(job) {
  return buildJobPageSeoDescription(job);
}

/**
 * Share targets for the job detail Share menu.
 * @returns {{ id: string, label: string, href?: string, action?: "copy" }[]}
 */
export function buildJobShareMenuItems(job) {
  const url = buildJobShareUrl(job);
  const title = buildJobShareTitle(job);
  const description = buildJobShareDescription(job);
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const tweetText = encodeURIComponent(`${title} — ${description}`);
  const waText = encodeURIComponent(`${title}\n${url}`);
  const emailSubject = encodeURIComponent(title);
  const emailBody = encodeURIComponent(`${description}\n\n${url}`);

  return [
    { id: "copy", label: "Copy link", action: "copy" },
    {
      id: "linkedin",
      label: "Share on LinkedIn",
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    },
    {
      id: "facebook",
      label: "Share on Facebook",
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    },
    {
      id: "x",
      label: "Share on X (Twitter)",
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${tweetText}`,
    },
    {
      id: "whatsapp",
      label: "Share via WhatsApp",
      href: `https://wa.me/?text=${waText}`,
    },
    {
      id: "email",
      label: "Share via Email",
      href: `mailto:?subject=${emailSubject}&body=${emailBody}`,
    },
  ];
}
